export default __webpack_public_path__ + "static/media/smootie.4e894494.jpg";